<template>
    <div id="app">
        <header>
            <div>
                <div class="left">
                    <a class="logo"></a>
                </div>
                <div class="right" v-if="isLogin">
                    <div class="user">
                        <i></i>
                        <a v-text="userName">王二</a>
                        <div class="list">
                            <a @click="logout()">退出登录</a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <transition name="fade0">
            <router-view @loginSuccess="loginSuccess" v-on:header="header" v-on:footer="footer"/>
        </transition>
        <footer><p
                v-text="'ver '+ version +' Copyright © '+ year +' Beijing HexFuture Technology Co., Ltd. All Rights Reserved 京ICP备16054026号-1'"></p>
        </footer>
    </div>
</template>

<script>
    import tools from './tools'

    let myDate = new Date();

    export default {
        name: 'App',
        watch: {
            //如果路由发生了变化，更新页面数据
            $route(to, from) {
                if (to.path !== from.path) {
                    this.isLogin = tools.getCookie("localtoken") !== null;
                }
            }
        },
        data() {
            return {
                version: '2.4.2.2',
                appCode: 21,
                year: myDate.getFullYear(),

                isLogin: tools.getCookie("localtoken") !== null,
                // isLogin: true

                userName: '',
            }
        },
        methods: {
            gotoNew: function () {
                this.$router.push({name: 'newResearch'});
            },
            logout: function () {
                tools.deleteCookie("localtoken");
                tools.deleteCookie("UserId");
                tools.deleteCookie("avatar");
                tools.deleteCookie("userName");
                tools.deleteCookie('reroute_schoolid');
                tools.deleteCookie('localtoken_save');

                this.isLogin = false;

                this.$router.push({name: 'login'});
            },
            loginSuccess: function () {
                this.isLogin = true;

                this.userName = tools.getCookie('userName');
            },
            header: function (isShowHeader) {
                if (isShowHeader == false) {
                    $("header").hide()
                } else {
                    $("header").show()
                }
            },
            footer: function (isShowFooter) {
                if (isShowFooter == false) {
                    $("footer").hide()
                } else {
                    $("footer").show()
                }
            },
            //  埋点
            burryPointFnc: function (needDatas,burryId) {
                try{
                    window.HexAnalysis.eventAnalysis(needDatas,burryId)
                }catch {

                }
            },
        },
        created() {
            window.appCode = this.appCode;
            window.version = this.version;
            window.burryPointHandler = this.burryPointFnc;
            //token校验、刷新时校验
            // if (tools.getCookie("UserId_save") && tools.getCookie("UserId_save") != "null" && tools.getCookie("UserId") && tools.getCookie("UserId_save") != tools.getCookie("UserId")) {
            //     this.logout();
            // } else {
            //     window.nowToken = tools.getCookie("localtoken");
            //     window.nowUserId = tools.getCookie("UserId");
            //     if (!isNaN(parseInt(window.nowUserId))) {
            //         tools.setCookie("UserId_save", window.nowUserId);
            //     }
            // }
        },
        mounted: function () {
            let that = this;

            if (tools.getCookie('localtoken') !== null && tools.getCookie('userName') === null) {
                tools.api(
                    'user.getUserInfo',
                    'Token=' + tools.getCookie('localtoken'),
                    function (user) {
                        tools.setCookie('localtoken', user.ssotoken);
                        tools.setCookie('UserId', user.Key);
                        tools.setCookie('avatar', user.Avatar);
                        tools.setCookie('userName', user.RealName);

                        that.userName = tools.getCookie('userName');
                    });
            } else {
                this.userName = tools.getCookie('userName');
            }

            // if (tools.getCookie('localtoken') !== null) {
            //     //判断编辑权限
            //     tools.api(
            //         'user.checkEditor',
            //         "",
            //         function (date) {
            //             if (!date) {
            //                 $('body').append('<div class="hex-network-error"><span class="haveFont">' + "该账号没有编辑权限，请重新登录！" + '</span></div>');
            //                 setTimeout(() => {
            //                     $('div.hex-network-error').remove();
            //                 }, 2000);
            //                 that.logout();
            //             }
            //         });
            // }
        }
    }
</script>

<style lang="sass">
    @import "./static/import"
    @include fadeAnimation(0)

    //==========================================谷歌浏览器设置滚动条=============================================
    ::-webkit-scrollbar
        width: 5px
        height: 5px

    ::-webkit-scrollbar-thumb
        background-color: #999999
        border-radius: 5px
        min-height: 40px

    input:focus, button:focus, textarea:focus
        outline: none

    i
        font-style: normal
</style>
